export default __webpack_public_path__ + "static/media/show4.3e1787f8.jpeg";